export default "__VITE_ASSET__b5958e11__"